export default "__VITE_ASSET__DBAM5MEH__"